<template>
	<div class="customer">
		<!-- <el-button v-if="dialogVisible" type="text" @click="dialogVisible = true">{{
      customerName
    }}</el-button> -->
		<customer-search
			class="customer-search"
			v-model="customer"
			v-show="searchIsShow"
			:default-key="customerName"
			placeholder="请输入客户名称/客户ID/CID"
			@change="getItem"
			@focus="cancel"
		></customer-search>

		<!-- <el-dialog
      v-if="dialogVisible"
      title="选择客户"
      :visible.sync="dialogVisible"
      width="30%"
    >
      <customer-search
        v-model="customer"
        :default-key="customerName"
        @change="getItem"
      ></customer-search>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </span>
    </el-dialog> -->
	</div>
</template>

<script>
import customerSearch from '@/components/iglobalwin/formComponents/account/customerSearch';
import { mapGetters, mapActions } from 'vuex';
import Vue from 'vue';
import searchIsShowList from './searchIsShow';

export default {
	name: 'customer',
	components: {
		customerSearch,
	},
	computed: {
		// 使用对象展开运算符将 getter 混入 computed 对象中
		...mapGetters(['customerName', 'customerId']),
		searchIsShow() {
			let { name } = this.$route;
			return !searchIsShowList.includes(name);
		},
	},
	watch: {
		customerId(val) {
			this.customer = val;
			this.item.id = val;
		},
		customerName(val) {
			this.item.value = val;
		},
	},
	created() {
		Vue.prototype.$showCustomerDialog = this.showCustomerDialog;
	},
	data() {
		return {
			dialogVisible: false,
			customer: '',
			item: {},
		};
	},
	methods: {
		...mapActions(['getWeblist']),
		showCustomerDialog() {
			this.dialogVisible = true;
		},
		async confirm() {
			this.$store.commit('SET_CUSTOMERID', this.customer);
			this.$store.commit('SET_CUSOMERNAME', this.item && this.item.value);
			this.dialogVisible = false;
			await this.getWeblist(this.customer);
		},
		cancel() {
			// this.customer = this.customerId;
			this.customer = '';
			this.dialogVisible = false;
		},
		getItem(item) {
			this.item = item;
			this.confirm();
		},
	},
};
</script>

<style lang="scss" scoped>
.customer {
	height: 100%;
	display: flex;
	justify-content: flex-start;
	align-items: center;
	margin-left: 20px; //内联样式的更改
}

.customer-select {
	width: 420px;
}
</style>
